import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC'
];

const PurchaseTable = ({ data }) => {
  const formatNumber = num => (num || 0).toLocaleString('en-GB');
  return (
    <div className="table-responsive">
      <Table bordered>
        <thead style={{ backgroundColor: '#3e5f7f', color: '#fff' }}>
          <tr>
            <th
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: 'transparent'
              }}
            ></th>
            {months.map(m => (
              <th key={m}>{m}</th>
            ))}
            <th>Total</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              <td>{row.yearVal}</td>

              {months.map(m => {
                const key = m.toLowerCase() + 'Val';
                return <td key={m}>{formatNumber(row[key])}</td>;
              })}

              <td>{formatNumber(row.totalVal)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

PurchaseTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      year: PropTypes.number.isRequired,
      jan: PropTypes.number,
      feb: PropTypes.number,
      mar: PropTypes.number,
      apr: PropTypes.number,
      may: PropTypes.number,
      jun: PropTypes.number,
      jul: PropTypes.number,
      aug: PropTypes.number,
      sep: PropTypes.number,
      oct: PropTypes.number,
      nov: PropTypes.number,
      dec: PropTypes.number,
      total: PropTypes.number
    })
  )
};
export default PurchaseTable;
